const Login = {
    title: 'Log In',
    forgot_password: 'Forgot your password?'
}
export default Login;
